// cart-reload.js

(function () {
  // Run only on /cart page
  if (window.location.pathname === "/cart") {
    window.onload = function () {
        setTimeout(() => {
            const discountField = document.querySelector(".bold-discount-field");

            if (discountField && discountField.children.length === 0) {
              console.log("No children found inside .bold-discount-field, reloading...");
              // Forces reload (deprecated in modern browsers, but kept as requested)
              window.location.reload(true);
            } else {
              console.log("Children exist or .bold-discount-field not found, no reload.");
            }
        }, 5000);
      
    };
  }
})();

